import { SANITIZE_PROFILE_DEFAULT } from 'app/utils/htmlSanitizer/profiles/default';
import { SANITIZE_PROFILE_DIXA_MESSENGER } from 'app/utils/htmlSanitizer/profiles/dixaMessenger';
import { SANITIZE_PROFILE_EMAIL } from 'app/utils/htmlSanitizer/profiles/email';
import { SANITIZE_PROFILE_EMAIL_SHADOW_DOM } from 'app/utils/htmlSanitizer/profiles/emailShadowDom';
import { SANITIZE_PROFILE_HIGHLIGHT } from 'app/utils/htmlSanitizer/profiles/highlight';
import { SANITIZE_PROFILE_MESSAGING } from 'app/utils/htmlSanitizer/profiles/messaging';
import { SANITIZE_PROFILE_NOTE } from 'app/utils/htmlSanitizer/profiles/note';
import { SANITIZE_PROFILE_RESTRICTED } from 'app/utils/htmlSanitizer/profiles/restricted';
import { SANITIZE_PROFILE_WIDGETCHAT } from 'app/utils/htmlSanitizer/profiles/widgetchat';
import {
  SanitizationCategory,
  SanitizationOption,
} from 'app/utils/htmlSanitizer/types';

export const sanitizationProfiles: Record<
  SanitizationCategory,
  SanitizationOption
> = {
  email: SANITIZE_PROFILE_EMAIL,
  emailShadowDom: SANITIZE_PROFILE_EMAIL_SHADOW_DOM,
  widgetchat: SANITIZE_PROFILE_WIDGETCHAT,
  messaging: SANITIZE_PROFILE_MESSAGING,
  note: SANITIZE_PROFILE_NOTE,
  default: SANITIZE_PROFILE_DEFAULT,
  restricted: SANITIZE_PROFILE_RESTRICTED,
  highlight: SANITIZE_PROFILE_HIGHLIGHT,
  dixaMessenger: SANITIZE_PROFILE_DIXA_MESSENGER,
};
